export default function formDataFromObject(object) {
  const formData = new FormData();

  for (let [key, value] of Object.entries(object)) {
    formData.append(key, value);
  }

  return formData;
}
